module.exports = __webpack_public_path__ + "static/media/no-image-available.8584d12a.png";